const AssetTypes = {
  SET_LOADING: 'ASSET_LIBRARY_ASSETS_SET_LOADING',
  SET_ERROR: 'ASSET_LIBRARY_ASSETS_SET_ERROR',
  FETCH_ASSETS_SUCCESS: 'ASSET_LIBRARY_ASSETS_FETCH_ASSETS_SUCCESS',
  UPLOAD_ASSET_SUCCESS: 'ASSET_LIBRARY_ASSETS_UPLOAD_ASSET_SUCCESS',
  UPDATE_ASSET_SUCCESS: 'ASSET_LIBRARY_ASSETS_UPDATE_ASSET_SUCCESS',
  DELETE_ASSET_SUCCESS: 'ASSET_LIBRARY_ASSETS_DELETE_ASSET_SUCCESS',
  BULK_DELETE_SUCCESS: 'ASSET_LIBRARY_ASSETS_BULK_DELETE_SUCCESS',
  DUPLICATE_ASSET_SUCCESS: 'ASSET_LIBRARY_ASSETS_DUPLICATE_ASSET_SUCCESS',
  SET_FILTER: 'ASSET_LIBRARY_ASSETS_SET_FILTER',
  RESET_FILTERS: 'ASSET_LIBRARY_ASSETS_RESET_FILTERS',
  SET_PAGE: 'ASSET_LIBRARY_ASSETS_SET_PAGE',
  SET_VIEW_MODE: 'ASSET_LIBRARY_ASSETS_SET_VIEW_MODE',
  TOGGLE_SELECT_ASSET: 'ASSET_LIBRARY_ASSETS_TOGGLE_SELECT_ASSET',
  SELECT_ALL_ASSETS: 'ASSET_LIBRARY_ASSETS_SELECT_ALL_ASSETS',
  CLEAR_SELECTION: 'ASSET_LIBRARY_ASSETS_CLEAR_SELECTION',
  SET_ACTIVE_ASSET: 'ASSET_LIBRARY_ASSETS_SET_ACTIVE_ASSET',
  SET_UPLOAD_PANEL_OPEN: 'ASSET_LIBRARY_ASSETS_SET_UPLOAD_PANEL_OPEN',
  SET_INFO_PANEL_OPEN: 'ASSET_LIBRARY_ASSETS_SET_INFO_PANEL_OPEN',
  SET_DOWNLOAD_PANEL_OPEN: 'ASSET_LIBRARY_ASSETS_SET_DOWNLOAD_PANEL_OPEN',
  SET_SHARE_PANEL_OPEN: 'ASSET_LIBRARY_ASSETS_SET_SHARE_PANEL_OPEN',
  SET_LOCATIONS_PANEL_OPEN: 'ASSET_LIBRARY_ASSETS_SET_LOCATIONS_PANEL_OPEN',
  SET_COMMENTS_PANEL_OPEN: 'ASSET_LIBRARY_ASSETS_SET_COMMENTS_PANEL_OPEN',
  SET_INFO_DETAILS_PANEL_OPEN: 'ASSET_LIBRARY_ASSETS_SET_INFO_DETAILS_PANEL_OPEN',
  SET_INFO_PANEL_MODE: 'ASSET_LIBRARY_ASSETS_SET_INFO_PANEL_MODE',
  LOAD_MORE_ASSETS_SUCCESS: 'ASSET_LIBRARY_ASSETS_LOAD_MORE_ASSETS_SUCCESS',
  FETCH_ASSET_LOCATIONS_START: 'ASSET_LIBRARY_ASSETS_FETCH_ASSET_LOCATIONS_START',
  FETCH_ASSET_LOCATIONS_SUCCESS: 'ASSET_LIBRARY_ASSETS_FETCH_ASSET_LOCATIONS_SUCCESS',
  FETCH_ASSET_LOCATIONS_ERROR: 'ASSET_LIBRARY_ASSETS_FETCH_ASSET_LOCATIONS_ERROR',
  FETCH_MASTER_OPTIONS_START: 'ASSET_LIBRARY_ASSETS_FETCH_MASTER_OPTIONS_START',
  FETCH_MASTER_OPTIONS_SUCCESS: 'ASSET_LIBRARY_ASSETS_FETCH_MASTER_OPTIONS_SUCCESS',
  FETCH_MASTER_OPTIONS_ERROR: 'ASSET_LIBRARY_ASSETS_FETCH_MASTER_OPTIONS_ERROR',
  SET_PRODUCT_FILTER: 'ASSET_LIBRARY_ASSETS_SET_PRODUCT_FILTER',
  FETCH_ASSETS_PAGE_SUCCESS: 'ASSET_LIBRARY_ASSETS_FETCH_ASSETS_PAGE_SUCCESS',
  NEXT_PAGE: 'ASSET_LIBRARY_ASSETS_NEXT_PAGE',
  PREV_PAGE: 'ASSET_LIBRARY_ASSETS_PREV_PAGE',
} as const;

export default AssetTypes;
